import React from 'react';
import { Main, Project, Contact, Navigation, Footer } from './components';
import FamiliarProblems from './components/FamiliarProblems';
import WhatIBuild from './components/WhatIBuild';
import AISection from './components/AISection';
import EngineeringWorkCta from './components/EngineeringWorkCta';
import JsonLd from './components/JsonLd';
import ScrollProgress from './components/ui/ScrollProgress';
import { useThemeMode } from './hooks/useThemeMode';

function LandingPage() {
  const { mode, handleModeChange } = useThemeMode();

  return (
    <>
      <ScrollProgress />
      <Navigation
        parentToChild={{ mode }}
        modeChange={handleModeChange}
        variant="landing"
      />
      <div className={`main-container ${mode === 'dark' ? 'dark-mode dark' : 'light-mode'}`}>
        <JsonLd />
        <main>
          <Main />
          <FamiliarProblems />
          <WhatIBuild />
          <AISection />
          <Project limit={3} defaultView="business" showToggle={false} />
          <EngineeringWorkCta />
          <Contact audience="business" />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default LandingPage;
